module.exports = __webpack_public_path__ + "static/media/pic-14.27cda7cb.jpg";